import styled from 'styled-components';

import { primitive } from '../../designTokens/primitives';
import { mediaQuery } from '../../globalStyles';

export const HeaderContainer = styled.div<{ variant: 'header-only' | 'call-to-action' }>`
  display: grid;
  align-items: center;
  grid-template-columns: ${(p) => (p.variant === 'header-only' ? '1fr' : '1fr 1fr;')};
  padding-block-start: ${primitive.$spacing6};
  padding-block-end: ${primitive.$spacing4};
  padding-inline: 0;
  margin-block: 0;
  margin-inline-start: 6%;
  margin-inline-end: 0;

  @media ${mediaQuery.tablet} {
    background: none;
    padding-block-start: ${primitive.$spacing10};
    padding-block-end: ${primitive.$spacing4};
    padding-inline: 0;
    grid-template-columns: ${(p) => (p.variant === 'header-only' ? '1fr' : '1fr auto 1fr;')};
    margin: 0 6%;
  }

  @media ${mediaQuery.desktopLarge} {
    margin: 0;
  }
`;

export const Header = styled.h3<{ variant: 'header-only' | 'call-to-action' }>`
  font: ${(p) => p.theme.token('text-style-module')};
  color: ${(p) => p.theme.token('text-default')};
  grid-column-start: 1;
  margin: 0;

  @media ${mediaQuery.tablet} {
    grid-column-start: ${(p) => (p.variant === 'header-only' ? 1 : 2)};
    text-align: center;
  }
`;

export const CallToActionButtonWrapper = styled.div`
  justify-self: end;
`;
